import React from 'react';

import useEventMeetEventDropdown from './UseEventMeetEventDropdown';

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const EventMeetEventDropdown = ({ label, name, value, error, message, onChange, meetEventId }) => {
  const { eventMeetEventState } = useEventMeetEventDropdown(meetEventId);

  return eventMeetEventState.message
    ? <span className={global.LoadingMsg}>{eventMeetEventState.message}</span>
    : (
      <Dropdown
        error={error}
        label={label}
        message={message}
        options={eventMeetEventState.items}
        name={name}
        value={value}
        onChange={onChange}
        isLoading={eventMeetEventState.isArrayLoading}
        areValuesIntegers={true}
      />
    );
};

export default EventMeetEventDropdown;